/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdAdditionalDataQueryResponse,
  GetApiV1PersonIdAdditionalDataPathParams,
  GetApiV1PersonIdAdditionalData401,
  GetApiV1PersonIdAdditionalData404,
  GetApiV1PersonIdAdditionalData500,
} from "../../types/personRegisterController/GetApiV1PersonIdAdditionalData.ts";

function getGetApiV1PersonIdAdditionalDataUrl(
  id: GetApiV1PersonIdAdditionalDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/additional-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados adicionais de uma pessoa (profissão, formação, observações). **(Requer Authorization para autenticação)**
 * @summary Obter dados adicionais (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/additional-data}
 */
export async function getApiV1PersonIdAdditionalData(
  id: GetApiV1PersonIdAdditionalDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdAdditionalDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAdditionalData401
      | GetApiV1PersonIdAdditionalData404
      | GetApiV1PersonIdAdditionalData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdAdditionalDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
